class StatusSolicitacaoInventarioIBPEnum {
    constructor(cod, desc) {
      this.cod = cod;
      this.desc = desc;
    }
  
    static fromcod(cod) {
      return Object.values(StatusSolicitacaoInventarioIBPEnum).find(status => status.cod === cod);
    }
  
    static fromDesc(desc) {
      return Object.values(StatusSolicitacaoInventarioIBPEnum).find(status => status.desc === desc);
    }
  }
  
  StatusSolicitacaoInventarioIBPEnum.EM_DIGITACAO = new StatusSolicitacaoInventarioIBPEnum(200, "Em Digitação");
  StatusSolicitacaoInventarioIBPEnum.EM_ANDAMENTO = new StatusSolicitacaoInventarioIBPEnum(201, "Em Andamento");
  StatusSolicitacaoInventarioIBPEnum.APROVADO_RFID = new StatusSolicitacaoInventarioIBPEnum(202, "Aprovado - RFID");
  StatusSolicitacaoInventarioIBPEnum.APROVADO = new StatusSolicitacaoInventarioIBPEnum(203, "Aprovado");
  StatusSolicitacaoInventarioIBPEnum.REPROVADO = new StatusSolicitacaoInventarioIBPEnum(204, "Reprovado");
  StatusSolicitacaoInventarioIBPEnum.FINALIZADO = new StatusSolicitacaoInventarioIBPEnum(205, "Finalizado");
  
  export default StatusSolicitacaoInventarioIBPEnum;